// removed by extract-text-webpack-plugin
module.exports = {"macro_container":"_3lRqULqMkUE_rR_2ujWa0o","binary_macro_item":"_39vnCbekjiwnvj4TW2o6lm"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryMacro/BinaryMacro.scss
// module id = 2247
// module chunks = 1